module.exports = __webpack_public_path__ + "img/analytics-download-vector.2fbe2924.svg";